module.exports = __webpack_public_path__ + "static/media/eye.61b0a01f.svg";